import Swiper, { Navigation, EffectFade, Autoplay, Pagination } from 'swiper';

let quoteOptions = {
    modules: [Navigation, Autoplay, EffectFade, Pagination],
    loop: true,
    spaceBetween: 0,
    speed: 1000,
    grabCursor: true,
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: { crossFade: true },
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    },
    autoplay: {
        delay: 6000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false
    },
};


let quote = new Swiper(".testimonials__swiper", quoteOptions);